import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/',
      name: 'home1',
      component: () => import('./views/Home1.vue')
    },
    {
      path: '/',
      name: 'footer',
      component: () => import('./views/footer.vue')
    },
    {
      path: '/',
      name: 'header',
      component: () => import('./views/header.vue')
    },
    {
      path: '/templete1',
      name: 'templete1',
      component: () => import('./views/templete1.vue'),
    },
    {
      path: '/text1',
      name: 'text1',
      component: () => import('./views/text1.vue'),
    },
    {
      path: '/text2',
      name: 'text2',
      component: () => import('./views/text2.vue'),
    },
    {
      path: '/price',
      name: 'price',
      component: () => import('./views/price.vue'),
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import('./views/pay.vue'),
    },
    {
      path: '/templete2',
      name: 'templete2',
      component: () => import('./views/templete2.vue'),
    },
    {
      path: '/templete3',
      name: 'templete3',
      component: () => import('./views/templete3.vue'),
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('./views/News.vue'),
    },
    {
      path: '/newsdetails/:id',
      name: 'newsdetails',
      component: () => import('./views/NewsDetails.vue'),
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product.vue'),
    },
    {
      path: '/case',
      name: 'case',
      component: () => import('./views/Case.vue')
    },
    {
      path: '/technology',
      name: 'technology',
      component: () => import('./views/Technology.vue')
    },
    {
      path: '/FAQ',
      name: 'FAQ',
      component: () => import('./views/FAQ.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/about.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/contact.vue')
    },
    {
      path: '/FAQ',
      name: 'FAQ',
      component: () => import('./views/FAQ.vue')
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('./views/map.vue')
    },
    {
      path: '/text',
      name: 'text',
      component: () => import('./views/text.vue')
    },

    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/privacy.vue')
    },
    {
      path: '/alipay',
      name: 'alipay',
      component: () => import('./views/alipay.vue')
    },
    {
      path: '/useragreement',
      name: 'useragreement',
      component: () => import('./views/useragreement.vue')
    },

    {
      path: '/usercenter',
      name: 'usercenter',
      component: () => import('./views/UserCenter.vue')
    },

    {
      path: '/casedetails/:id',
      name: 'casedetails',
      component: () => import('./views/CaseDetails.vue')
    },
    {
      path: '/goin',
      name: 'goin',
      component: () => import('./views/GoIn.vue')
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('./views/Download.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('./views/Test.vue')
    },
    {
      path: '/textLoad',
      name: 'textLoad',
      component: () => import('./views/textLoad.vue')
    },
    {
      path: '/loginfront',
      name: 'loginfront',
      component: () => import('./views/loginFront.vue')
    },
    {
      path: '/share',
      name: 'share',
      component: () => import('./views/share.vue')
    },
    {
      path: '/guest',
      name: 'guest',
      component: () => import('./views/Guest.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      meta: {
        requireAuth: true
      },
      component: () => import('./views/Admin.vue'),
      children: [{
          path: '/admin/user',
          name: 'user',
          component: () => import('./views/Admin/User.vue')
        },
        {
          path: '/admin/news',
          name: 'new',
          component: () => import('./views/Admin/News.vue')
        },
        {
          path: '/admin/cases',
          name: 'cases',
          component: () => import('./views/Admin/Cases.vue')
        },
        {
          path: '/admin/team',
          name: 'team',
          component: () => import('./views/Admin/Team.vue')
        },
        {
          path: '/admin/course',
          name: 'course',
          component: () => import('./views/Admin/Course.vue')
        },
        {
          path: '/admin/enterprise',
          name: 'enterprise',
          component: () => import('./views/Admin/Enterprise.vue')
        },
        {
          path: '/admin/honor',
          name: 'honor',
          component: () => import('./views/Admin/Honor.vue')
        },
        {
          path: '/admin/dictionary',
          name: 'dictionary',
          component: () => import('./views/Admin/Dictionary.vue')
        },
        {
          path: '/admin/page',
          name: 'page',
          component: () => import('./views/Admin/Page.vue')
        }
      ]
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {

    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }

  // 未登录不能访问usercenter
  if (to.path === '/usercenter/' && localStorage.getItem('loginStatus') === 'false') {
    next('/login');
  } else {
    next(); 
  }
})

// kejianrouter.afterEach((to, from)=>{
// if(to.name==="templete3"){
//   kejianrouter.push(
//       {name:"templete2", params: {
//       Parms: to.params
//       // 添加其他参数...
//     }, })
// }
//   console.log(to)
//   console.log(from)
// })

export default kejianrouter